/* Stamp preferences belong to one cart line, never to the whole order. */
(() => {
  if (window.__ttpLineStampBound) return;
  window.__ttpLineStampBound = true;
  const propertyName = "TTP Bookseller's Stamp";
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let locked = [];
  const isStamp = key => key.includes('TTP Bookseller') && key.includes('Stamp');
  async function request(path, body) {
    const response = await fetch(root + path, body ? {
      method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)
    } : {cache: 'no-store'});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || 'Could not save');
    return data;
  }
  function lock() {
    busy = true;
    document.documentElement.classList.add('ttp-stamp-saving');
    locked = [...document.querySelectorAll('cart-items-component button, cart-items-component input, cart-items-component select, button[name="checkout"], .ttp-line-stamp__select')]
      .filter(el => !el.disabled);
    locked.forEach(el => { el.disabled = true; });
  }
  function unlock() {
    locked.forEach(el => { if (el.isConnected) el.disabled = false; });
    locked = [];
    busy = false;
    document.documentElement.classList.remove('ttp-stamp-saving');
  }
  document.addEventListener('submit', event => {
    if (busy && (event.target.matches('.cart-form') || event.submitter?.name === 'checkout')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', event => {
    if (busy && event.target.closest('a[href*="checkout"], button[name="checkout"], .cart-page__summary, .cart-items__quantity')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', async event => {
    const select = event.target.closest?.('.ttp-line-stamp__select');
    if (!select || busy) return;
    const chosen = select.value;
    const status = select.closest('.ttp-line-stamp').querySelector('[role="status"]');
    lock();
    status.textContent = 'Saving this book’s choice…';
    try {
      const cart = await request('cart.js');
      const item = cart.items.find(line => line.key === select.dataset.key);
      if (!item) throw new Error('Your cart changed. Refresh and try again.');
      // Preserve every unrelated property and the latest quantity.
      const properties = {...item.properties};
      Object.keys(properties).filter(isStamp).forEach(key => { delete properties[key]; });
      properties[propertyName] = chosen;
      if (cart.attributes?.['Bookshop stamp']) {
        await request('cart/update.js', {attributes: {'Bookshop stamp': ''}});
      }
      await request('cart/change.js', {id: item.key, quantity: item.quantity, properties});
      // A property update changes line keys and may merge identical lines.
      // Reload server-rendered rows so every control gets its correct new key.
      window.location.reload();
    } catch (error) {
      select.value = select.dataset.saved;
      status.textContent = 'Could not save this choice. Please refresh and try again.';
      unlock();
    }
  });
  // Remove only the obsolete order-wide stamp attribute, never other preferences.
  async function clearLegacy() {
    if (!document.querySelector('[data-legacy-stamp="true"]') || busy) return;
    lock();
    try {
      await request('cart/update.js', {attributes: {'Bookshop stamp': ''}});
      document.querySelectorAll('[data-legacy-stamp]').forEach(el => {el.dataset.legacyStamp = 'false';});
      unlock();
    } catch (error) {
      const status = document.querySelector('.ttp-line-stamp__status');
      if (status) status.textContent = 'Could not refresh stamp preferences. Please reload before checking out.';
      // Keep checkout locked rather than submit a conflicting legacy instruction.
    }
  }
  /* The stamp is on by default. A book can still reach the bag with no choice
     recorded on the line — added from a "Read next" card, a quick add, or an
     older cart. The row already shows "Yes", so write that onto the line too;
     otherwise the order would not tell us to stamp it. An explicit "No" is
     never touched, because those lines carry the property already. */
  const loopGuard = 'ttpStampBackfillAt';
  function guardedRecently() {
    try { return Date.now() - Number(sessionStorage.getItem(loopGuard) || 0) < 10000; }
    catch (error) { return false; }
  }
  async function stampByDefault() {
    const rows = [...document.querySelectorAll('.ttp-line-stamp[data-stamp-missing="true"]')];
    if (!rows.length || busy || guardedRecently()) return;
    lock();
    try {
      const cart = await request('cart.js');
      let written = false;
      for (const row of rows) {
        const select = row.querySelector('.ttp-line-stamp__select');
        const item = cart.items.find(line => line.key === select?.dataset.key);
        if (!item) continue;
        const properties = {...item.properties};
        if (Object.keys(properties).some(isStamp)) continue;
        properties[propertyName] = 'Yes';
        await request('cart/change.js', {id: item.key, quantity: item.quantity, properties});
        written = true;
      }
      if (written) {
        try { sessionStorage.setItem(loopGuard, String(Date.now())); } catch (error) { /* private mode */ }
        // Line keys change with properties, so redraw rather than keep stale ones.
        window.location.reload();
        return;
      }
      unlock();
    } catch (error) {
      // Leave the row as it is: it already reads Yes, and the customer can
      // set it by hand. Never block checkout over this.
      unlock();
    }
  }
  clearLegacy().then(stampByDefault);
})();
